<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a @click="backfenxiao()" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>斐燃合伙人</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="fxb">
      <div class="fxb_title">请选择VIP激活码</div>
      <div @click="chooseCard(3)" class="fxb_item">
        <div class="fxb_item_left">
          <div class="fxb_item_left_title">
            <img v-show="card_select == 3" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_yes.png" />
            <img v-show="card_select != 3" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_no.png" />
            黄金卡2021
          </div>
          <!-- <div class="fxb_item_left_stitle">每月免费使用1次预约权益，共计12次</div> -->
          <div class="fxb_item_left_stitle">门市价五折/次，嘉宾 门市价五折/次</div>
        </div>
        <div class="fxb_item_right">
          <div class="fxb_item_right_title">¥ 288.00</div>
          <div class="fxb_item_right_stitle">预估收益 :  ¥28.8</div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div @click="chooseCard(1)" class="fxb_item">
        <div class="fxb_item_left">
          <div class="fxb_item_left_title">
            <img v-show="card_select == 1" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_yes.png" />
            <img v-show="card_select != 1" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_no.png" />
            铂金卡2021
          </div>
          <div class="fxb_item_left_stitle fxb_item_left_stitless">每月免费使用1次预约权益，共计12次</div>
          <div class="fxb_item_left_stitle">超出单价 门市价五折/次，嘉宾 门市价五折/次</div>
        </div>
        <div class="fxb_item_right">
          <div class="fxb_item_right_title">¥ 1188.00</div>
          <div class="fxb_item_right_stitle">预估收益 :  ¥118.8</div>
        </div>
        <div class="clearboth"></div>
      </div>
      <div @click="chooseCard(2)" class="fxb_item">
        <div class="fxb_item_left">
          <div class="fxb_item_left_title">
            <img v-show="card_select == 2" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_yes.png" />
            <img v-show="card_select != 2" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_no.png" />
            钻石卡2021
          </div>
          <div class="fxb_item_left_stitle fxb_item_left_stitless">每周免费使用1次预约权益，共计52次</div>
          <div class="fxb_item_left_stitle">超出单价 门市价五折/次，嘉宾 门市价五折/次</div>
        </div>
        <div class="fxb_item_right">
          <div class="fxb_item_right_title">¥ 3888.00</div>
          <div class="fxb_item_right_stitle">预估收益 :  ¥388.8</div>
        </div>
        <div class="clearboth"></div>
      </div>

      <div @click="chooseCard(4)" class="fxb_item">
        <div class="fxb_item_left">
          <div class="fxb_item_left_title">
            <img v-show="card_select == 4" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_yes.png" />
            <img v-show="card_select != 4" class="fxb_item_left_title_icon" src="../../../assets/images/fenxiao/fx_choose_sport_no.png" />
            斐然黑金
          </div>
          <div class="fxb_item_left_stitle fxb_item_left_stitless">每日免费使用1次预约权益，共计365次</div>
          <div class="fxb_item_left_stitle">超出单价 门市价¥88/次，嘉宾 门市价¥88/次</div>
        </div>
        <div class="fxb_item_right">
          <div class="fxb_item_right_title">¥ 18888.00</div>
          <div class="fxb_item_right_stitle">预估收益 :  ¥1888.8</div>
        </div>
        <div class="clearboth"></div>
      </div>


    </div>
    <div class="fxb_submit">
      <div class="fxb_submit_tip">
        <div class="fxb_submit_tip_cont">
          *使用指南：<br />
          1、购买会员卡激活码<br />
          2、将激活码复制并发给您的意向客户<br />
          3、意向客户进入微信公众号【斐燃生活】>【激活】> 成为斐燃会员<br />
          4、分销金额到帐
        </div>
      </div>
      <div class="fxb_submit_submit">
        <button @click="buycard()" v-preventReClick>立即支付</button>
      </div>

    </div>
  </div>
</template>

<script>
  import {
    isPhone,
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        card_select:1,//1:铂金 2:钻石
      }
    },
    created() {},
    mounted() {
      this.getToken()
    },
    activated() { },
    methods: {
      // 判断用户是否登录
      getToken(){
        if(!localStorage.getItem("token")){
          this.$router.push({
            name:'login'
          })
        }
      },
      // 选择卡
      chooseCard(item){
        this.card_select=item
      },
      // 买卡
      buycard(){
        var $this=this
        console.log(this.card_select)
        let param = {
          token: localStorage.getItem("token"),
          id:this.card_select,
          fx_code: localStorage.getItem("fxcode"),
        }
        $this.$loading('正在提交');
        //
        var qs = require('qs');
        let url = this.api.userApi.fxBuyCdk
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)

          if(!result.data){
            $this.$loading.close()
            $this.$toast(result.msg);
          }else{
            let config = JSON.parse(result.data.pay_json);
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no), false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no));
                document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no));
              }
            } else {
              $this.onBridgeReady(config,result.data.order_no);
            }
          }

        }).catch((error) => {
          console.log(error)
          $this.$loading.close()
        })
      },
      onBridgeReady(config,order_no) {
        var $this = this
        WeixinJSBridge.invoke(
        'getBrandWCPayRequest', config,
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            var param={
              order_no:order_no
            }
            $this.$loading.close()
            $this.$router.push({
              name:'fxbuysuccess',
              params:param
            })
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            $this.$loading.close()
            $this.$toast("支付失败,请重新支付");
          } else {
            $this.$loading.close()
            $this.$toast("支付失败,请重新支付");
          }
        });
      },
      // 返回分销项目
      backfenxiao(){
        console.log('返回分销项目')
        var url=encodeURI(window.location.href)
        if(url.indexOf('test')==-1){
          window.location.href='https://agency.unionfit.cn'
        }else{
          window.location.href='https://test.agency.unionfit.cn'
        }
      }
    },
    destroyed: function() {}
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .container{
    height: 100vh;
  }
  .fxb{
    width: 100%;
    padding: 20*@vm_base 24*@vm_base 0 24*@vm_base;
    height: calc(100vh - 450*@vm_base);
    overflow: hidden;
    overflow-y: auto;
    .fxb_title{
      width: 100%;
      font-size: 28*@vm_base;
      color: #333333;
      padding: 30*@vm_base 0;
    }
    .fxb_item{
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 4*@vm_base 20*@vm_base 0px #EEEEEE;
      border-radius: 12*@vm_base;
      padding: 40*@vm_base 30*@vm_base;
      margin-bottom: 30*@vm_base;
      .fxb_item_left{
        width: calc(68% - 1*@vm_base);
        float: left;
        height: 120*@vm_base;
        border-right: 1*@vm_base solid #EBEBEB;
        .fxb_item_left_title{
          width: 100%;
          font-size: 32*@vm_base;
          font-weight: bold;
          color: #333333;
          margin-bottom: 22*@vm_base;
          height: 32*@vm_base;
          line-height: 32*@vm_base;
          .fxb_item_left_title_icon{
            width: 32*@vm_base;
            float: left;
            margin-right: 16*@vm_base;
          }
        }
        .fxb_item_left_stitle{
          width: 100%;
          // height: 30*@vm_base;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #7C7987;
          line-height: 30*@vm_base;
          margin-top: 4*@vm_base;
        }
        .fxb_item_left_stitless{
          white-space: nowrap;
        }
      }
      .fxb_item_right{
        width: 32%;
        float: left;
        height: 120*@vm_base;
        .fxb_item_right_title{
          width: calc(100% + 30*@vm_base);
          text-align: center;
          font-size: 32*@vm_base;
          font-weight: bolder;
          color: #333333;
          white-space: nowrap;
          padding-top: 15*@vm_base;
          padding-bottom: 15*@vm_base;
        }
        .fxb_item_right_stitle{
          width: calc(100% + 30*@vm_base);
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #7C7987;
          white-space: nowrap;
          text-align: center;
          height: 30*@vm_base;
          line-height: 30*@vm_base;
        }
      }
    }
  }
  .fxb_submit{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 350*@vm_base;
    // border: 1*@vm_base solid red;
    .fxb_submit_tip{
      width: 100%;
      padding: 0 32*@vm_base;
      .fxb_submit_tip_cont{
        font-size: 22*@vm_base;
        font-weight: 500;
        color: #7C7987;
        line-height: 30*@vm_base;
        margin-bottom: 40*@vm_base;
      }
    }
    .fxb_submit_submit{
      width: 100%;
      padding: 0 64*@vm_base 36*@vm_base 64*@vm_base;
      button{
        width: 100%;
        height: 90*@vm_base;
        background: #444054;
        border-radius: 12*@vm_base;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        border: none;
        outline: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/unpublic/fxbuycode/fxbuylist.vue